import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
    errorInfo: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  private handleReload = () => {
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      // Try to preserve participantId so the participant can resume
      const participantId = localStorage.getItem('participantId') || 'unknown';

      return (
        <div style={{
          padding: '40px',
          maxWidth: '600px',
          margin: '60px auto',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          textAlign: 'center'
        }}>
          <h2 style={{ color: '#c62828', marginBottom: '16px' }}>
            Something went wrong
          </h2>
          <p style={{ color: '#555', fontSize: '16px', lineHeight: '1.5', marginBottom: '24px' }}>
            An unexpected error occurred. Your progress has been saved automatically.
            Click the button below to reload and continue where you left off.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              backgroundColor: '#1976d2',
              color: '#fff',
              border: 'none',
              padding: '12px 32px',
              fontSize: '16px',
              borderRadius: '4px',
              cursor: 'pointer',
              marginBottom: '24px'
            }}
          >
            Reload and Continue
          </button>
          <details style={{ whiteSpace: 'pre-wrap', marginTop: '16px', textAlign: 'left', color: '#888', fontSize: '12px' }}>
            <summary>Technical details (for researchers)</summary>
            <p>Participant: {participantId}</p>
            {this.state.error && <p>{this.state.error.toString()}</p>}
            {this.state.errorInfo && <pre>{this.state.errorInfo.componentStack}</pre>}
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
